import { useContext } from 'react';

import { AnalyticsContext } from '../providers/AnalyticsProvider/index.ts';

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return context;
};
